(() => {
  const form = document.querySelector('[data-sa-blog-filters]');
  if (!form) return;

  const qInput = form.querySelector('[data-sa-blog-q]');
  const dateInput = form.querySelector('[data-sa-blog-date]');
  const clearBtn = form.querySelector('[data-sa-blog-clear]');
  const countEl = document.querySelector('[data-sa-blog-count]');
  const emptyEl = document.querySelector('[data-sa-blog-empty]');
  const items = [...document.querySelectorAll('[data-sa-blog-item]')];
  const total = items.length;

  const params = () => new URLSearchParams(window.location.search);

  const readUrl = () => {
    const search = params();
    if (qInput) qInput.value = search.get('q') || '';
    if (dateInput) dateInput.value = search.get('date') || '';
  };

  const writeUrl = (q, date) => {
    const search = params();
    if (q) search.set('q', q);
    else search.delete('q');
    if (date) search.set('date', date);
    else search.delete('date');
    const next = search.toString();
    const url = next ? `${window.location.pathname}?${next}` : window.location.pathname;
    window.history.replaceState({}, '', url);
  };

  const apply = ({ skipUrl } = {}) => {
    const q = (qInput?.value || '').trim().toLowerCase();
    const date = dateInput?.value || '';
    let visible = 0;

    items.forEach((item) => {
      const haystack = `${item.dataset.title || ''} ${item.dataset.content || ''}`.toLowerCase();
      const itemDate = item.dataset.date || '';
      const matchesQ = !q || haystack.includes(q);
      const matchesDate = !date || itemDate === date;
      const show = matchesQ && matchesDate;
      item.hidden = !show;
      item.classList.toggle('is-filtered-out', !show);
      if (show) visible += 1;
    });

    if (clearBtn) clearBtn.hidden = !(q || date);
    if (countEl) {
      countEl.hidden = total === 0;
      countEl.textContent =
        visible === total ? `${total} post${total === 1 ? '' : 's'}` : `${visible} of ${total} posts`;
    }
    if (emptyEl) emptyEl.hidden = visible !== 0;
    if (!skipUrl) writeUrl(q, date);
  };

  readUrl();
  apply({ skipUrl: true });

  form.addEventListener('input', () => apply());
  form.addEventListener('change', () => apply());
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    apply();
  });
  form.addEventListener('reset', (event) => {
    event.preventDefault();
    if (qInput) qInput.value = '';
    if (dateInput) dateInput.value = '';
    apply();
  });
})();
